import React from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Section, Toggle } from '../settingsPrimitives';
import { usePreferencesStore } from '../../store/preferencesStore';
import { isMacPlatform } from '../../utils/keyboard';

/**
 * Settings → Extensions → Terminal → "Keyboard" (macOS only; Terminal board
 * card 1, 21.10.2026): "Use Option as Meta key" (`terminalOptionAsMeta`,
 * default off — as in Terminal.app and iTerm2, because many layouts type
 * @ [ ] | with Option). Applied live to every open terminal.
 */
export default function TerminalKeyboardSetting() {
  const { t } = useTranslation();
  const optionAsMeta = usePreferencesStore((s) => s.terminalOptionAsMeta === true);
  const update = usePreferencesStore((s) => s.updatePreference);

  if (!isMacPlatform()) return null;
  return (
    <Section title={t('terminalExt.keyboardSection', 'Keyboard')}>
      <Row
        label={t('terminalExt.optionAsMeta', 'Use Option as Meta key')}
        desc={t(
          'terminalExt.optionAsMetaDesc',
          'Option+letter runs shell shortcuts (⌥B, ⌥F, ⌥D) instead of typing ∫, ƒ, ∂. Leave it off if you type @, [ or ] with Option. ⌥←/→ jump by word either way.',
        )}
      >
        <Toggle value={optionAsMeta} onChange={(v) => update('terminalOptionAsMeta', v)} />
      </Row>
    </Section>
  );
}
